import React, { useState, useEffect } from "react";
import { Grid, Select, FormControl, MenuItem, Card } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import api from "../../api";
import { useSelector } from "react-redux";

// Images
import tfa from "../../assets/Images/inlinefan.png";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: "-1vh",
  },
  formControl: {
    width: "max-content",
    minWidth: "100%",
    backgroundColor: "#eeeef5",
    fontFamily: "Arial",
    height: "6vh",
  },
  paper1: {
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "0px 0px 10px #0123B421",
    opacity: "1",
    borderRadius: "12px",
    height: "15vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "1vh 0",
  },
  cardHeading: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#000000",
    marginTop: "1vh",
    fontWeight: "bold",
    fontSize: "1.7vh",
    textAlign: "center",
  },
  select: {
    fontWeight: "bold",
    height: "6vh",
    borderRadius: "0.8vw",
    fontFamily: "Arial",
    "@media (min-width:1920px) and (max-width:2559.95px)": {
      fontSize: "2vh",
    },
    "& .MuiSvgIcon-root": {
      color: "white",
      backgroundColor: "#0123b4",
      borderRadius: "8px",
    },
    "& .MuiSelect-root": {
      marginTop: "-2vh",
    },
  },
  paper: {
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "1px 0px 8px 2px rgba(0, 0, 0, 0.14)",
    backgroundColor: "#fcfafa",
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
    borderRadius: "12px",
    opacity: "1",
  },
}));

export default function Eqp_Details() {
  const classes = useStyles();

  const [equipmentData, setEquipmentData] = useState({});
  const [selectedDevice, setSelectedDevice] = useState("");
  const [fdata, setFdata] = useState("all");
  const zone_data = useSelector((state) => state.inDashboard.locationData);
  const [fid, setFId] = useState("all");
  const [floor, setFloor] = useState([]);
  const buildingID = useSelector((state) => state.isLogged.data.building.id);

  useEffect(() => {
    let zone_id = "",
      z_data = [];
    zone_data.sort(function (a, b) {
      return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
    });
    zone_data.filter((_each) => _each.zone_type === "GL_LOCATION_TYPE_FLOOR");
    console.log("zone_data", zone_data, "fdata", fdata);

    if (fdata !== null && fdata !== "all") {
      zone_data.filter((_each, i) => {
        if (
          _each.zone_type === "GL_LOCATION_TYPE_FLOOR" &&
          _each.name === fdata
        ) {
          zone_id = _each.uuid;
          setFId(_each.uuid);
          return true;
        }
        return false;
      });
    }

    api.dashboard
      .getMetricData(buildingID)
      .then((res) => {
        const sorted = res.sort((a, b) =>
          a.name > b.name ? 1 : b.name > a.name ? -1 : 0
        );
        setFloor(sorted);
      })
      .catch((error) => {
        console.log(error);
      });
    api.floor.cpmGetDevData().then((res) => {
      const tfaOnly = { NONGL_SS_TFA: res["NONGL_SS_TFA"] };
      setEquipmentData(tfaOnly);
      setSelectedDevice("");
    });
  }, []);

  const typeNameMap = {
    NONGL_SS_TFA: "",
  };

  const typeImageMap = {
    NONGL_SS_TFA: tfa,
  };

  const selectedType = "NONGL_SS_TFA";
  const devices = equipmentData[selectedType]
    ? Object.entries(equipmentData[selectedType]).sort((a, b) =>
        a[1].name.localeCompare(b[1].name)
      )
    : [];

  const handleFloorChange = (name, id) => {
    console.log("Floor change:", id, name);
    setFId(id);
    setFdata(name);
    setSelectedDevice(id);
  };

  const allowedParameters = {
    TFA_AM_SS: <>Auto Manual<br />Status</>,
    TFA_RUN_SS: "Run Status",
    TFA_Trip_SS_Alarm: "Trip Status",
    TFA_Filter_SS: "Filter Status",
    TFA_Supply_Temp: "Temperature",
  };

  const getDisplayName = (attrKey) => {
    return allowedParameters[attrKey] || attrKey.replace(/_/g, " ");
  };

  const shouldShowParameter = (attrKey) => {
    return Object.keys(allowedParameters).includes(attrKey);
  };

  const getTripStatusColor = (attrKey, val) => {
    if (attrKey === "TFA_Trip_SS_Alarm") {
      return val === "1" || val === "active" || val === 1 ? "red" : "green";
    }
    return "#0123B4";
  };

 const formatValue = (attrKey, val) => {
 
  if (val === null || val === undefined || val === "") {
    return "-"; 
  }

  switch (attrKey) {
    case "TFA_RUN_SS":
      return val === "active" || val === 1 || val === "1" ? "ON" : "OFF";

    case "TFA_Trip_SS_Alarm":
      return val === "1" || val === "active" || val === 1 ? "Tripped" : "Normal";

    case "TFA_AM_SS":
      return val === "1" || val === "active" || val === 1 ? "Auto" : "Manual";

    case "TFA_Filter_SS":
      return val === "1" || val === "active" || val === 1 ? "Dirty" : "Clean";
    case "TFA_Supply_Temp":
      return !isNaN(parseFloat(val))
        ? `${parseFloat(val).toFixed(1)}°C`
        : "--";
    
    default:
      return val;
  }
};

  return (
    <div className={classes.root}>
      <Grid container spacing={1}>
        <Grid container item xs={12} spacing={2}>
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            lg={4}
            xl={4}
            style={{ marginLeft: "1vw" }}
          >
            <FormControl
              variant="filled"
              size="small"
              style={{
                width: "max-content",
                minWidth: "100%",
                backgroundColor: "#eeeef5",
              }}
            >
              <Select
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                label="Floor"
                className={classes.select}
                value={fdata}
                style={{
                  borderRadius: "0.8vw",
                  height: "6vh",
                  fontWeight: "bold",
                }}
                disableUnderline
              >
                <MenuItem
                  key="all-devices"
                  value="all"
                  onClick={() => handleFloorChange("all", "all")}
                >
                  All Floors
                </MenuItem>
                {floor.map((_item) => (
                  <MenuItem
                    key={_item.name}
                    value={_item.name}
                    onClick={() => handleFloorChange(_item.name, _item.id)}
                  >
                    {_item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        <Grid container item xs={12} spacing={2} style={{ marginTop: "2vh" }}>
          {devices
            .filter(([deviceId, deviceInfo]) =>
              fid === "all" ? true : deviceInfo?.Equipment_Group === fid
            )
            .map(([deviceId, deviceInfo]) => {
              const parameterOrder = Object.keys(allowedParameters);
              const filteredAttributes = deviceInfo?.Eqp_Attributes
                ? Object.entries(deviceInfo.Eqp_Attributes)
                    .filter(([attrKey]) => shouldShowParameter(attrKey))
                    .sort(
                      (a, b) =>
                        parameterOrder.indexOf(a[0]) -
                        parameterOrder.indexOf(b[0])
                    )
                : [];
              return (
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6} key={deviceId}>
                  <Card
                    className={classes.paper}
                    style={{
                      height: "auto",
                      minHeight: "48vh",
                      padding: "1.5vh",
                    }}
                  >
                    <Grid container spacing={1} style={{ marginTop: "0.5vh" }}>
                      <Grid
                        item
                        xs={12}
                        style={{ textAlign: "left", marginLeft: "2vh" }}
                      >
                        <div
                          style={{
                            color: "black",
                            fontWeight: "bold",
                            fontSize: "2.5vh",
                            marginLeft: "2vh",
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                            lineHeight: "1.2",
                            textAlign: "left",
                          }}
                        >
                          {/* {typeNameMap[selectedType]}-{" "} */}
                          {/* {floor.find(
                            (f) => f.id === deviceInfo.Equipment_Group
                          )?.name || ""}{" "} */}
                          {deviceInfo.name}
                        </div>
                      </Grid>
                    </Grid>

                    <Grid container spacing={1} style={{ marginTop: "0.5vh" }}>
                      <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                            marginTop: "3.5vh",
                            minHeight: "25vh",
                          }}
                        >
                          <img
                            src={typeImageMap[selectedType]}
                            alt={typeNameMap[selectedType]}
                            style={{
                              width: "100%",
                              maxWidth: "180px",
                              height: "auto",
                              maxHeight: "25vh",
                              objectFit: "contain",
                            }}
                          />
                        </div>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        sm={8}
                        md={8}
                        lg={8}
                        xl={8}
                        style={{
                          paddingRight: "1vw",
                        }}
                      >
                        <Grid container spacing={1}>
                          {filteredAttributes.map(([attrKey, attrValue]) => (
                            <Grid
                              item
                              xs={6}
                              sm={4}
                              md={4}
                              lg={4}
                              xl={4}
                              key={attrKey}
                            >
                              <Card className={classes.paper1}>
                                <div className={classes.cardHeading}>
                                  {getDisplayName(attrKey)}
                                </div>
                                <div
                                  style={{
                                    fontSize: "2.5vh",
                                    color: getTripStatusColor(
                                      attrKey,
                                      attrValue.presentValue
                                    ),
                                    fontWeight: "bold",
                                    whiteSpace: "nowrap",
                                    marginBottom: "2vh",
                                  }}
                                >
                                  {formatValue(attrKey, attrValue.presentValue)}
                                </div>
                              </Card>
                            </Grid>
                          ))}
                          {filteredAttributes.length > 0 && (
                            <Grid item xs={6} sm={4} md={4} lg={4} xl={4}>
                              <Card className={classes.paper1}>
                                <div className={classes.cardHeading}>
                                  &nbsp;
                                </div>
                              </Card>
                            </Grid>
                          )}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              );
            })}
        </Grid>
      </Grid>
    </div>
  );
}
